import React from 'react';
import { T, fontBody } from './tokens';

export default function ActionRow({ icon: Icon, label, value, tint }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0' }}>
      <div style={{ width: 26, height: 26, borderRadius: 7, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: tint }}>
        <Icon sx={{ fontSize: 13, color: T.ink }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <span style={{ fontFamily: fontBody, fontSize: 11, color: T.slateLight, fontWeight: 500 }}>{label}</span>
        <span style={{
          fontFamily: fontBody, fontSize: 13, color: T.ink, fontWeight: 500,
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        }}
        >
          {value}
        </span>
      </div>
    </div>
  );
}
